/*
 * @Author: xiaolong.xu
 * @Date: 2023-08-22 17:46:54
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-10-24 15:12:29
 * @Description: file content
 */
import { useRouter } from "next/router";

export enum PAGE_TYPES {
  EDM_EC = "EDM-EC",
  EDM_GAME = "EDM-Game",
  EDM_APP = "EDM-APP",
  EDM_GENERAL = "EDM-General",
  WECHAT_GENERAL = "Wechat-General",
}

const usePageType = () => {
  const router = useRouter();
  const { type } = router.query;

  return type;
};

export default usePageType;
